define('models/product',['require','backbone'],function (require) {
  var Backbone = require("backbone");

  return Backbone.Model.extend({
    url: function () {
      // set the endpoint for restful api for articles
      return this.id ?( App.Config.apiBase + "products/" + this.id + "/" ) :
        ( App.Config.apiBase + "products/" );
    },

    defaults: function () {
      return {
        id: null,
        name: "",
        license_name: "",
        category: 0,
        type: 0,
        is_listed: true,
        is_listed_customer: true,
        is_listed_distributor: true,
        is_listed_cd: true,
        store_order: 0,
        license_type: 0,
        payment_schedule: 0,
        effective_price: 0,
        info: "",
        is_okc_based: false,
        is_activation_required: true,
        is_main_product: false,
        image_name: "SambaPOS-default.png",
        image_width: 1,
        image_height: 1,
        regional_visibility: 0,
        translations: {
          en: {
            name: null,
            info: null,
          },
          tr: {
            name: null,
            info: null,
          },
        },
        is_inc_gq: false,
        product_info_schema: null,
        is_recurring: false
      };
    },
  });
});

